// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__6jWny","icon":"styles_icon__sn4a3"};